import { initialStateBase } from './newCollection';

export const initialState = {
    ...initialStateBase,
    getCouponsData: {},
    getCouponsDataError: {},
    validateCouponsData: {},
    couponValidateError: {},
    metadataKey: 'coupons'
};

export const urls = {
    getCoupons: '/api/coupons/search',
    validateCoupons: '/api/coupons/validate'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RESPONSE_POST_GET_COUPONS':
            return {
                ...state,
                getCouponsData: {
                    ...action.data,
                    isFetching: false
                },
                getCouponsDataError: {}
            };
        case 'ERROR_POST_GET_COUPONS':
            return {
                ...state,
                getCouponsDataError: {
                    ...action.data,
                    isFetching: false
                }
            };
        case 'REQUEST_GET_COUPONS':
            return {
                ...state,
                getCouponsData: {
                    ...state.getCouponsData.data,
                    isFetching: true
                },
                getCouponsDataError: {}
            };

        case 'RESPONSE_POST_VALIDATE_COUPON':
            return {
                ...state,
                validateCouponsData: action.data,
                couponValidateError: {}
            };
        case 'ERROR_POST_VALIDATE_COUPON':
            return {
                ...state,
                couponValidateError: action.data
            };
        case 'EMPTY_VALIDATED_COUPON':
            return {
                ...state,
                validateCouponsData: {},
                couponValidateError: {}
            };
        case 'ERROR_COUPON_EMPTY_VALIDATION':
            return {
                ...state,
                couponValidateError: {}
            };
        default:
            return state;
    }
};
